<template>
  <div class="kft-horizontal-carousel-wrapper w-full">
    <div class="kft-horizontal-carousel-wrapper__container">
      <template v-if="!hideNavigation">
        <slot name="right-arrow">
          <div
            v-show="itemsLength > 1"
            class="kft-horizontal-carousel-wrapper__right-arrow"
            @click="handleScrollRight"
          >
            <div
              class="w-8 h-8 lg:w-10 lg:h-10 kft-horizontal-carousel-wrapper__arrow-container flex justify-center items-center"
              :class="{
                'kft-horizontal-carousel-wrapper__arrow-container--mobile':
                  isMobile,
                'kft-horizontal-carousel-wrapper__arrow-container--tablet':
                  isTablet,
              }"
            >
              <ChevronRight class="ml-0.5 text-black" />
            </div>
          </div>
        </slot>
        <slot name="left-arrow">
          <div
            v-show="itemsLength > 1"
            class="kft-horizontal-carousel-wrapper__left-arrow"
            @click="handleScrollLeft"
          >
            <div
              :class="{
                'kft-horizontal-carousel-wrapper__arrow-container--mobile':
                  isMobile,
                'kft-horizontal-carousel-wrapper__arrow-container--tablet':
                  isTablet,
              }"
              class="w-8 h-8 lg:w-10 lg:h-10 kft-horizontal-carousel-wrapper__arrow-container flex justify-center items-center"
            >
              <ChevronLeft class="mr-0.5 text-black" />
            </div>
          </div>
        </slot>
      </template>
      <div
        ref="scrollableContainerRef"
        class="flex gap-4 px-4 flex-nowrap kft-horizontal-carousel-wrapper__cards-container py-3"
        data-test-id="horizontal-carousel-wrapper"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ChevronRight from '~/assets/icons/chevron-right.svg?component'
import ChevronLeft from '~/assets/icons/chevron-left.svg?component'

const emit = defineEmits(['scroll:left', 'scroll:right'])
const { itemsLength, hideNavigation = false } = defineProps<{
  itemsLength: number
  hideNavigation: boolean
}>()

const scrollableContainerRef = ref(null)

const { isMobile, isTablet } = useDevice()
const handleScrollLeft = () => {
  emit('scroll:left')
}
const handleScrollRight = () => {
  emit('scroll:right')
}
</script>

<style lang="postcss" scoped>
.kft-horizontal-carousel-wrapper__cards-container {
  overflow: hidden;
}
.kft-horizontal-carousel-wrapper__cards-container::-webkit-scrollbar {
  display: none;
}
.kft-horizontal-carousel-wrapper__container {
  width: 100%;
  position: relative;
}
.kft-horizontal-carousel-wrapper__arrow-container {
  cursor: pointer;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 50%;
  z-index: 2;
  position: relative;
}
.kft-horizontal-carousel-wrapper__arrow-container i {
  display: block;
  line-height: 42px;
  text-align: center;
}
.kft-horizontal-carousel-wrapper__right-arrow,
.kft-horizontal-carousel-wrapper__left-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
}
.kft-horizontal-carousel-wrapper__right-arrow {
  right: 0;
}
.kft-horizontal-carousel-wrapper__left-arrow {
  left: 0;
}
</style>
